<template>
    <div style="width: 100%;height: 100%;padding: 10px;">
        <el-form :inline="true" class="myfrom">
            <el-form-item label="门店">
                <el-select v-model="storeid" placeholder="请选择门店" @change="storeChange" size="mini">
                    <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in brands" :key="key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" type="primary" @click="douYinCjData" :loading="querybutton">查询</el-button>
            </el-form-item>
            <el-form-item label="日期">
                <el-date-picker style="width: 220px;"
                                value-format="yyyy-MM-dd"
                                size="mini"
                                v-model="pickerData"
                                type="daterange"
                                align="right"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                :clearable="false"
                                :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <el-table v-loading="querybutton"  size="mini" :data="douYinData" highlight-current-row height="calc(100% - 8rem)" ref="table" border show-summary :summary-method="getSummaries">
            <el-table-column label="门店" width="100px" align="center" prop="storename" fixed="left"></el-table-column>
            <el-table-column label="体验" width="60px" align="center" prop="number" ></el-table-column>
            <el-table-column label="大项" width="60px" align="center" prop="dxnumber" ></el-table-column>
            <el-table-column label="成交" width="60px" align="center" prop="cjnumber" ></el-table-column>
            <el-table-column label="成交率" width="100px" align="center" prop="cjlv" >
                <template slot-scope="scope">
                    {{$percentgae(scope.row.cjlv)}}
                </template>
            </el-table-column>
            <el-table-column label="成交金额" width="100px" align="center" prop="payamount" ></el-table-column>
        </el-table>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                brands:[],
                querybutton:false,
                storeid:localStorage.getItem("storeid"),
                pickerData:[
                    this.$moment().format('YYYY-MM-DD'),
                    this.$moment().format('YYYY-MM-DD')
                ],
                querybutton:false,
                douYinData:[],
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '今天',
                            onClick:(picker)=> {
                                const start=this.$moment().format('YYYY-MM-DD');
                                picker.$emit('pick', [start, start]);
                            }
                        },
                        {
                            text: '昨天',
                            onClick:(picker)=> {
                                const start=this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                                picker.$emit('pick', [start, start]);
                            }
                        },
                        {
                            text: '本周',
                            onClick:(picker)=> {
                                const start=this.$moment().startOf('week').add(1, 'days').format('YYYY-MM-DD');
                                const end =this.$moment().endOf('week').add(1, 'days').format('YYYY-MM-DD');
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '上一周',
                            onClick:(picker)=>{
                                const start=this.$moment().startOf('week').subtract(6, 'days').format('YYYY-MM-DD');
                                const end =this.$moment().endOf('week').subtract(6, 'days').format('YYYY-MM-DD');
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '本月',
                            onClick:(picker)=>{
                                const start=this.$moment().startOf('month').format('YYYY-MM-DD');
                                const end =this.$moment().endOf('month').format('YYYY-MM-DD');
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '上个月',
                            onClick:(picker)=> {
                                const start=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                                const num=this.$moment(start, "YYYY-MM-DD").daysInMonth();
                                picker.$emit('pick', [start+'-01', start+'-'+num]);
                            }
                        },
                    ],
                },
            }
        },
        created() {
            this.getStoreInfoByStructsOpen();
            this.douYinCjData();
        },
        updated () {
            this.$nextTick(() => {
                this.$refs['table'].doLayout();
            })
        },
        methods:{
            getSummaries(param) {
                const {columns, data} = param;
                const sums = [];
                let that=this;
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if(index===4){
                        sums[index] = that.$percentgae(sums[3]/sums[1]);
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = 'N/A';
                    }
                });
                return sums;
            },
            douYinCjData(){
                let fromdate=this.pickerData[0];
                let todate=this.pickerData[1];
                this.querybutton=true;
                this.$post("beautymanager/getHairDouYinCjLv",{storeid:this.storeid,fromdate:fromdate,todate:todate}).then(res=>{
                    this.querybutton=false;
                    if(res.sucess){
                        this.douYinData=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
            storeChange(val){
                localStorage.setItem("storeid",val);
                this.storeid=val;
                this.douYinCjData();
            },
            getStoreInfoByStructsOpen(){
                let parentstoreid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:parentstoreid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.brands=res.object;
                    }
                    else{
                        this.$message({
                            message: res.message,
                            type: 'error'
                        });
                    }
                });
            },
        }
    }
</script>
<style style lang="scss" rel="stylesheet/scss">
    .myfrom .el-form-item{
        margin-bottom:0px;
    }
</style>


// WEBPACK FOOTER //
// src/page/manager/hairdouyincjlv.vue